// extracted by mini-css-extract-plugin
export default {"empty":"Index_empty__GPT6E","captcha":"Index_captcha__XSezi","button":"Index_button__EB7oQ","action":"Index_action__NI9wt","action_item":"Index_action_item__pYE0-"};